import createReactComponent from '../createReactComponent';
export default createReactComponent('mobile-signal-three', 'MobileSignalThree', [["path",{"d":"M3 21v-1m9 1v-9m-4.5 9v-5","key":"svg-0"}]]);